module.exports = __webpack_public_path__ + "static/media/wakanda-bg.dc2855da.jpg";